/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require("./bootstrap");
require("./select2");
require("./jquery.ex-table-filter");

//window.Vue = require('vue');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i);
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

//Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

/*const app = new Vue({
    el: '#app',
});*/

$(".datepicker").datepicker({
    dateFormat: "yy-mm-dd",
});
$(".datepicker2").datepicker({
    dateFormat: "y/mm/dd",
});

$("#adjust_price").on("change", function () {
    var normal_price = Number($(this).data("normal-price"));
    var price = Number($(this).data("price"));
    var price_ex_tax = Number($(this).data("price_ex_tax"));
    var cost = Number($(this).data("cost"));
    var adjust = Number($(this).val());

    price = price + adjust;
    cost = cost - adjust;
    total_mgn =
        (100 * Math.round((1000 * (price_ex_tax - cost)) / price_ex_tax)) /
        1000;

    total_discount = Math.round(1000 * (1 - price / normal_price)) / 10;

    $("#total_price").text(commaSeparated(price)); //税込
    $("#total_mgn").text(total_mgn); //税抜きで算出したtotalmgn
    $("#total_discount").text(total_discount); //割引
});

$(".rate-calc1").on("change", function () {
    calcGMImport($(this).data("id"), $(this).data("base"), 1);
});

$("input[name=use_jl]").on("change", function () {
    id = $("input[name=product_id]").val();
    listino = $("input[name=listino_price_ex_tax]").val();
    //console.log(listino);
    if ($("input[name=use_jl]:checked").val() == 0) {
        $(".fix_jl").prop("disabled", true);
        jl = $("input[name=auto_jl]").val();
    } else {
        $(".fix_jl").prop("disabled", false);
        jl = $("input[name=fix_jl]").val();
    }

    //console.log(jl);
    if (jl > 0) {
        base = 1000 * Math.round((listino * jl) / 1000);
        $(".rate-calc1").data("base", base);
        $("input[name=price]").val(base);
        $("#jpd_final_price").text(commaSeparated(base));

        var tax = $("input[name=tax]").val() * 1;
        base_with_tax =
            Math.floor(100 * Math.floor((base * (100 + tax)) / 100)) / 100;
        $("#jpd_final_price_with_tax").text(commaSeparated(base_with_tax));

        calcGMImport(id, base, 1);
    }
});

$(".fix_jl").on("change", function () {
    id = $("input[name=product_id]").val();
    listino = $("input[name=listino_price_ex_tax]").val();
    jl = $(this).val();

    if (jl > 0) {
        base = 1000 * Math.round((listino * jl) / 1000);
        $(".rate-calc1").data("base", base);
        $("input[name=price]").val(base);
        $("#jpd_final_price").text(commaSeparated(base));

        var tax = $("input[name=tax]").val() * 1;
        base_with_tax =
            Math.floor(100 * Math.floor((base * (100 + tax)) / 100)) / 100;
        $("#jpd_final_price_with_tax").text(commaSeparated(base_with_tax));

        calcGMImport(id, base, 1);
    }
});

$(".rate-calc2").on("change", function () {
    //console.log("xxxx");
    if ($("input[name=product_import]:checked").val() == 1) {
        //console.log("aaa");
        calcGMImport($(this).data("id"), $(this).data("base"), 2);
    } else {
        //console.log("bbb");
        calcGmDomestic($(this).data("id"));
    }
});

function calcGMImport(id, price, type) {
    //console.log("---calcGMImport---");
    //console.log(type);
    //console.log(price);
    //var id=$(this).data('id');
    var target_saleprice = $("#saleprice-" + id);
    var target = $("#subtotal-" + id);
    //var price=$(this).data('base');
    var rate_base = $("input[name=discount]").data("rate");
    var rate_new = $("input[name=discount]").val();
    var adjustprice =
        $("#adjustprice-" + id).length > 0 ? $("#adjustprice-" + id).val() : 0;
    adjustprice = adjustprice.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function (s) {
        return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
    });
    adjustprice = adjustprice.replace(/,/g, "");

    var quantity = $("#quantity-" + id).val();
    var rate = $("#rate-" + id).val();
    var saleprice = 0;

    //console.log(rate_base);
    //console.log(rate_new);
    //console.log(adjustprice);
    //console.log(quantity);
    //console.log(rate);
    //console.log(saleprice);

    //レート変更
    if (type == 1) {
        //console.log("--レート変更--");
        saleprice = Math.floor(price - (price * rate_new) / 100);
        //レートベース値を入力値に更新
        $("input[name=discount]").data("rate", rate_new);
        //調整価格をリセット
        $("#adjustprice-" + id).val(0);
    } else {
        //console.log("--価格調整--");
        saleprice = Math.floor(price - (price * rate_base) / 100);
        saleprice = saleprice + Number(adjustprice);
        tmp_rate = Math.floor((1000 * (price - saleprice)) / price) / 10;
        $("#rate-" + id).val(tmp_rate);
    }

    /*if(Number(adjustprice)==0){
        saleprice=Math.floor(price - price*rate/100);
        console.log('aaa');
        console.log(saleprice);

    }else{
    */
    //        saleprice=Math.floor(price - price*rate/100) + Number(adjustprice);

    //console.log("bbb");
    //console.log(saleprice);
    //        console.log(tmp_rate);

    //}

    //＋の位で丸める
    saleprice = Math.round(saleprice / 1000) * 1000;

    var subtotal = 0;
    subtotal = quantity * saleprice;

    target_saleprice.val(commaSeparated(saleprice));
    target.val(commaSeparated(subtotal));

    if ($("#gross_yen").length > 0) {
        var gross_yen = $("#gross_yen").val();
        var gross_margin = (100 * (saleprice - gross_yen)) / saleprice;
        //console.log(gross_margin);
        var gross_margin = Math.round(gross_margin * 10) / 10;
        //console.log(gross_margin);

        $("#gross_margin").text(gross_margin);
    }
}

function commaSeparated(num) {
    return String(num).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
}

$(".new_attr").on("change", function () {
    var id = $(this).data("id");
    if ($(this).prop("checked") == true) {
        $("#new_attr_wrap_" + id).show();
    } else {
        $("#new_attr_wrap_" + id).hide();
    }
});

$(".new_attr_val").on("click", function () {
    var name = $(this).data("name");
    var wrap = $(this).parents(".new_attr_wrap").find(".new_attr_val_wrap");
    wrap.append(
        '<div class="input-group flex-nowrap"><input type="text" name="' +
            name +
            '" value="" class="form-control"><span class="input-group-text del_attr_val btn btn-danger">×</span></div>'
    );
});

$(document).on("click", ".del_attr_val", function () {
    $(this).parent(".input-group").remove();
});

$(".select_attr").on("change", function () {
    var val = $(this).val();
    var id = $(this).data("id");

    $(".attr_wrap_" + id).hide();
    $(".attr_wrap_" + id + " input").prop("disabled", true);

    if ($(".attr_wrap_" + id + "_" + val).length) {
        $(".attr_wrap_" + id + "_" + val).show();
        $(".attr_wrap_" + id + "_" + val + " input").prop("disabled", false);
    } else {
        if (val == "") {
            $(".new_attr_" + id).show();
            $(".new_attr_" + id + " input").prop("disabled", false);
        } else {
            $(".new_attr_" + id).hide();
            $(".new_attr_" + id + " input").prop("disabled", true);
        }
    }
});
$(".select_attr_create").on("change", function () {
    var val = $(this).val();
    var id = $(this).data("id");

    if (val == "") {
        $(".new_attr_" + id).show();
        $(".new_attr_" + id + " input").prop("disabled", false);
    } else {
        $(".new_attr_" + id).hide();
        $(".new_attr_" + id + " input").prop("disabled", true);
    }
});

//顧客選択用
$(".select2-ajax").select2({
    ajax: {
        url: "/ajax/customer",
        dataType: "json",
        processResults(response) {
            // データをselect2向けに加工
            let options = [];
            response.data.forEach((user) => {
                options.push({
                    id: user.id,
                    text: user.name1 + " " + user.name2,
                });
            });
            return {
                results: options,
                pagination: {
                    more: response.next_page_url !== null, // 次ページがあるかどうか
                },
            };
        },
    },
});

//受注選択用
$(".select2-ajax-order").select2({
    multiple: "multiple",
    ajax: {
        url: "/ajax/order",
        dataType: "json",
        processResults(response) {
            // データをselect2向けに加工
            let options = [];
            response.data.forEach((order) => {
                options.push({
                    id: order.id,
                    text:
                        order.number +
                        ":" +
                        order.title +
                        "(" +
                        order.customer_name +
                        "様)",
                });
            });
            return {
                results: options,
                pagination: {
                    more: response.next_page_url !== null, // 次ページがあるかどうか
                },
            };
        },
    },
});

//選択された注文詳細を取得
var selected_orders = [];
$(".select2-ajax-order").on("change", function () {
    var order_ids = $(this).val();
    getOrderDetail(order_ids, []);
});
function getOrderDetail(order_ids, selected_ids, po_id = "") {
    selected_ids = selected_ids.map((str) => parseInt(str, 10));
    //console.log("selected_ids****");
    //console.log(selected_ids);
    //追加されたID
    added_ids = order_ids.filter((i) => selected_orders.indexOf(i) == -1);
    //console.log("add");
    //console.log(added_ids);

    //削除されたID
    deleted_ids = selected_orders.filter((i) => order_ids.indexOf(i) == -1);
    //console.log("del");
    //console.log(deleted_ids);

    //最新の選択値をセット
    selected_orders = order_ids;

    //新規取得
    for (i = 0; i < added_ids.length; i++) {
        var order_id = added_ids[i];

        $.ajax({
            url: "/ajax/orderdetail/" + order_id + "?po_id=" + po_id,
            type: "GET",
            dataType: "json",
        }).done((data) => {
            //console.log(data);
            //console.log("/**selected**/");
            //console.log(selected_ids);
            var html = "";

            html += '<div class="col-md-12" id="order-' + data.order_id + '">';
            html += '    <div class="card">';
            html +=
                '        <div class="card-header d-flex align-items-center justify-content-between">';
            html += "            <div>";
            html +=
                '<input class="form-check-input all-check all-check-' +
                data.order_id +
                '" data-id="' +
                data.order_id +
                '" type="checkbox" style="cursor:pointer;" checked>　';
            html += data.orderName;
            html += "            </div>";
            html += "            <div>";
            html += "            </div>";
            html += "        </div>";
            html += '        <div class="card-body">';

            //輸入
            var html_sub = "";
            for (j = 0; j < data.products.length; j++) {
                var product = data.products[j];
                if (product.import == 1) {
                    if (selected_ids.length == 0) {
                        //console.log("length=0");
                        checked_str = "checked";
                    } else {
                        //console.log("length>=1");
                        //console.log(product.id);
                        //console.log($.inArray(product.id, selected_ids));
                        if ($.inArray(product.id, selected_ids) === -1) {
                            checked_str = "";
                        } else {
                            checked_str = "checked";
                        }
                    }
                    html_sub += "<tr>";
                    html_sub +=
                        '<td><input type="checkbox" name="order_products[' +
                        data.order_id +
                        '][]" value="' +
                        product.id +
                        '" style="cursor:pointer;" class="form-check-input order-product input-' +
                        data.order_id +
                        '" data-id="' +
                        data.order_id +
                        '" ' +
                        checked_str +
                        "></td>";
                    html_sub += "<td>" + product.name + "</td>";
                    html_sub += "<td>" + product.price + "</td>";
                    html_sub += "<td>" + product.sale_price + "</td>";
                    html_sub += "</tr>";
                }
            }
            if (html_sub) {
                html += '<div class="table-responsive">';
                html += '<h6 style="font-weight: bold">●輸入</h6>';
                html += '<table class="table text-nowrap">';
                html += "    <tr>";
                html += "        <th>選択</th>";
                html += "        <th>見積商品名</th>";
                html += "        <th>通常価格(税抜)</th>";
                html += "        <th>提案価格(税抜)</th>";
                html += "    </tr>";
                html += html_sub;
                html += "</table>";
                html += "</div>";
            }

            //国内
            var html_sub = "";
            for (j = 0; j < data.products.length; j++) {
                var product = data.products[j];
                if (product.import == 2) {
                    if (selected_ids.length == 0) {
                        checked_str = "checked";
                    } else {
                        if ($.inArray(product.id, selected_ids) === -1) {
                            checked_str = "";
                        } else {
                            checked_str = "checked";
                        }
                    }
                    html_sub += "<tr>";
                    html_sub +=
                        '<td><input type="checkbox" name="order_products[' +
                        data.order_id +
                        '][]" value="' +
                        product.id +
                        '" style="cursor:pointer;" class="form-check-input order-product input-' +
                        data.order_id +
                        '" data-id="' +
                        data.order_id +
                        '" ' +
                        checked_str +
                        "></td>";
                    html_sub += "<td>" + product.name + "</td>";
                    html_sub += "<td>" + product.price + "</td>";
                    html_sub += "<td>" + product.sale_price + "</td>";
                    html_sub += "</tr>";
                }
            }
            if (html_sub) {
                html += '<div class="table-responsive">';
                html += '<h6 style="font-weight: bold">●国内仕入</h6>';
                html += '<table class="table text-nowrap">';
                html += "    <tr>";
                html += "        <th>選択</th>";
                html += "        <th>見積商品名</th>";
                html += "        <th>通常価格(税抜)</th>";
                html += "        <th>提案価格(税抜)</th>";
                html += "    </tr>";
                html += html_sub;
                html += "</table>";
                html += "</div>";
            }

            html += "        </div>";
            html += "    </div>";
            html += "</div>";

            $("#order_detail").append(html);
        });
    }

    //削除
    for (i = 0; i < deleted_ids.length; i++) {
        var order_id = deleted_ids[i];
        $("#order-" + order_id).remove();
    }
}

//編集時初期セット
if ($(".select2-ajax-order").length > 0) {
    var order_ids = $(".select2-ajax-order").val();
    var selected_ids = $("#selected_ids").val().split(",");
    var po_id = $("#po_id").val();
    getOrderDetail(order_ids, selected_ids, po_id);
}

//全チェック/解除
$(document).on("click", ".all-check", function () {
    //    console.log($(this).data('id'));
    var id = $(this).data("id");
    if ($(this).prop("checked")) {
        $(".input-" + id).prop("checked", true);
    } else {
        $(".input-" + id).prop("checked", false);
    }
});
//個別チェック時全フラグ連動
$(document).on("click", ".order-product", function () {
    //    console.log($(this).data('id'));
    var id = $(this).data("id");
    var all_check = true;

    $(".input-" + id).each(function () {
        if ($(this).prop("checked") == false) {
            all_check = false;
        }
    });

    //    console.log(all_check);
    $(".all-check-" + id).prop("checked", all_check);
});

//国内仕入れGM算出
function calcGmDomestic(id) {
    //console.log("id:" + id);
    var sikiri_rate = $("input[name=d_sikiri_rate]").val() * 1;
    //console.log("sikiri:" + sikiri_rate);
    var discount_rate = $("input[name=d_discount]").val() * 1;
    //console.log("off:" + discount_rate);

    var jpd = $("input[name=price]").val() * 1;
    //console.log("jpd:" + jpd);

    var mitsumori = $("input[name=d_mitsumori]").val() * 1;
    //console.log("mitsumori:" + mitsumori);

    if ($("input[name=d_tax_include]").prop("checked")) {
        //console.log("税込");
        var tax = $("input[name=tax]").val() * 1;
        //税抜きに変換
        //小数点第2位まで
        mitsumori =
            Math.floor(100 * Math.ceil(mitsumori / ((100 + tax) / 100))) / 100;
    }

    var target_price = 0;
    if (mitsumori) {
        target_price = mitsumori;
    } else {
        target_price = jpd;
    }

    //console.log("target_price:" + target_price);

    //console.log((100 - sikiri_rate - discount_rate) / 100);
    //console.log(target_price * ((100 - sikiri_rate - discount_rate) / 100));

    var adjustprice =
        $("#adjustprice-" + id).length > 0 ? $("#adjustprice-" + id).val() : 0;
    adjustprice = adjustprice.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function (s) {
        return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
    });
    adjustprice = adjustprice.replace(/,/g, "");
    //console.log("adjust:" + adjustprice);

    //売値（提案価格）
    var saleprice =
        Math.floor((target_price * (100 - discount_rate)) / 100) +
        adjustprice * 1;
    $("input[name=sale_price]").val(commaSeparated(saleprice));

    //gross￥
    var gross_yen = Math.floor((target_price * sikiri_rate) / 100);
    $("#d_gross_yen").text("¥" + commaSeparated(gross_yen));

    //goross margin
    //100*round(1000*($this->sale_price - $this->d_gross_yen()) / $this->sale_price)/1000 ;
    var gm =
        (100 * Math.round((1000 * (saleprice - gross_yen)) / saleprice)) / 1000;

    $("#d_gross_margin").text(gm);
}
$(".d_rate_calc").on("change", function () {
    calcGmDomestic();
});

function checkInput(val) {
    if (val == 1) {
        //console.log("輸入");
        //輸入
        $("input[name=d_sikiri_rate]")
            .attr("disabled", true)
            .attr("readonly", true)
            .css("background-color", "#999");
        $("input[name=d_discount]")
            .attr("disabled", true)
            .attr("readonly", true)
            .css("background-color", "#999");
        $("input[name=d_mitsumori]")
            .attr("disabled", true)
            .attr("readonly", true)
            .css("background-color", "#999");
        $("input[name=d_tax_include]")
            .attr("disabled", true)
            .attr("readonly", true)
            .css("background-color", "#999");
        $("input[name=d_company_name]")
            .attr("disabled", true)
            .attr("readonly", true)
            .css("background-color", "#999");

        $("input[name=discount]")
            .attr("disabled", false)
            .attr("readonly", false)
            .css("background-color", "");

        calcGMImport(
            $("input[name=discount]").data("id"),
            $("input[name=discount]").data("base"),
            1
        );
    } else {
        //console.log("国内");
        //国内
        $("input[name=d_sikiri_rate]")
            .attr("disabled", false)
            .attr("readonly", false)
            .css("background-color", "");
        $("input[name=d_discount]")
            .attr("disabled", false)
            .attr("readonly", false)
            .css("background-color", "");
        $("input[name=d_mitsumori]")
            .attr("disabled", false)
            .attr("readonly", false)
            .css("background-color", "");
        $("input[name=d_tax_include]")
            .attr("disabled", false)
            .attr("readonly", false)
            .css("background-color", "");
        $("input[name=d_company_name]")
            .attr("disabled", false)
            .attr("readonly", false)
            .css("background-color", "");

        $("input[name=discount]")
            .attr("disabled", true)
            .attr("readonly", true)
            .css("background-color", "#999");

        calcGmDomestic($("input[name=discount]").data("id"));
    }
}

$("input[name=product_import]").on("change", function () {
    checkInput($(this).val());
});

if ($("input[name=product_import]").length > 0) {
    //console.log("init");
    checkInput($("input[name=product_import]:checked").val());
}

if ($("#order_table").length > 0) {
    // --- 列ごとのチェックボックスリスト生成 ---
    $("#order_table thead th").each(function (colIndex) {
        let uniqueVals = new Set();

        $("#order_table tbody tr").each(function () {
            //let val = $(this).find('td').eq(colIndex).text().trim();
            let val = $(this)
                .find("td")
                .eq(colIndex)
                .clone() // td内を複製して
                .find("select") // selectを探し
                .remove() // 消して
                .end()
                .text()
                .trim();

            uniqueVals.add(val);
        });

        // チェックボックスを生成して div.filterX に追加
        let container = $(`.filter${colIndex}`);

        // 先にクリアボタンを追加
        let clearBtn = $(`
            <button type="button"
                    class="btn btn-sm  mb-2 clear-filter"
                    data-col="${colIndex}">
                クリア
            </button>
        `);
        container.append(clearBtn);

        uniqueVals.forEach(function (val) {
            let cb = $(
                `<label class="me-2"><input type="checkbox" data-col="${colIndex}" value="${val}"> ${val}</label>`
            );
            container.append(cb);
        });
    });

    // --- 列ごとのフィルタークリア ---
    $(document).on("click", ".clear-filter", function () {
        let col = $(this).data("col");

        // 該当列のチェックを全解除
        $(`input[type="checkbox"][data-col="${col}"]`)
            .prop("checked", false)
            .trigger("change"); // フィルター再適用用
    });

    $(document).on(
        "change",
        ".ex-filter input,.filter0 input, .filter1 input, .filter2 input",
        function () {
            $("#order_table tbody tr").each(function () {
                let show = true;

                $(this)
                    .find("td")
                    .each(function (colIndex) {
                        let checkedVals = $(`.filter${colIndex} input:checked`)
                            .map(function () {
                                return $(this).val();
                            })
                            .get();
                        let btn = $(`.filter${colIndex}`)
                            .parents("th")
                            .find(".btn");

                        if (checkedVals.length > 0) {
                            let cellVal = $(this)
                                .clone() // td内を複製して
                                .find("select") // selectを探し
                                .remove() // 消して
                                .end()
                                .text()
                                .trim();

                            if (!checkedVals.includes(cellVal)) {
                                show = false;
                                return false; // この行は非表示
                            }

                            btn.addClass("btn-success").removeClass(
                                "btn-primary"
                            );
                        } else {
                            btn.removeClass("btn-success").addClass(
                                "btn-primary"
                            );
                        }
                    });

                $(this).toggle(show);

                // 非表示行のチェック解除
                if (!show) {
                    $(this)
                        .find('input[type="checkbox"]')
                        .prop("checked", false);
                }

                displayColmun();
            });
        }
    );

    /*let tblfilters = {};

    for (let i = 0; i <= 20; i++) {
        tblfilters[i] = {
            append: {
                to: `div.filter${i}`,
                type: "checkbox",
            },
        };
    }

    $("#order_table").exTableFilter({
        filters: tblfilters,
    });
    $(document).on("change keyup", "th input", function () {
        // 非表示行のチェック解除
        $('#order_table tbody tr:hidden input[name="col_po[]"]').prop(
            "checked",
            false
        );
        $('#order_table tbody tr:hidden input[name="col_invoice[]"]').prop(
            "checked",
            false
        );
        $('#order_table tbody tr:hidden input[name="col_supplier[]"]').prop(
            "checked",
            false
        );
        $(
            '#order_table tbody tr:hidden input[name="col_product_complete[]"]'
        ).prop("checked", false);
        $('#order_table tbody tr:hidden input[name="col_nouhinbi[]"]').prop(
            "checked",
            false
        );
    });
    */

    //120日アラート対応ボタン
    $(".do_action1").on("click", function () {
        let q_id = $(this).data("qpid");
        $.ajax({
            url: "/ajax/doaction1/" + q_id,
            type: "GET",
            dataType: "json",
        })
            .done((data) => {
                if (data.status) {
                    showToast("処理が成功しました", "success", 3000);
                    $('[data-qid="q_' + q_id + '"]')
                        .find(".col-alert")
                        .html("");
                    initExTableFilter();
                } else {
                    showToast("エラーが発生しました", "danger", 3000);
                }
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                showToast("エラーが発生しました", "danger", 3000);
            });
    });
    //240日アラート対応ボタン
    $(".do_action2").on("click", function () {
        let q_id = $(this).data("qpid");
        $.ajax({
            url: "/ajax/doaction2/" + q_id,
            type: "GET",
            dataType: "json",
        })
            .done((data) => {
                if (data.status) {
                    showToast("処理が成功しました", "success", 3000);
                    $('[data-qid="q_' + q_id + '"]')
                        .find(".col-alert")
                        .html("");
                    initExTableFilter();
                } else {
                    showToast("エラーが発生しました", "danger", 3000);
                }
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                showToast("エラーが発生しました", "danger", 3000);
            });
    });
    //PO更新
    $("#do_action_po").on("click", function () {
        let ids = $('input[name="col_po[]"]:checked')
            .map(function () {
                return $(this).val();
            })
            .get();
        //console.log(ids);
        if (ids.length === 0) {
            showToast("1つ以上選択してください", "danger"); // トースト表示
            return; // 処理を中断
        }
        let input_txt = $("#input_po").val();
        //console.log(input_txt);
        if (input_txt == "") {
            showToast("値を入力してください", "danger"); // トースト表示
            return; // 処理を中断
        }
        $.ajax({
            url: "/ajax/do_action_po/",
            type: "GET",
            dataType: "json",
            data: {
                ids: ids,
                str: input_txt,
            },
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
        })
            .done((data) => {
                if (data.status) {
                    $('input[name="col_po[]"]:checked').each(function () {
                        $(this).closest("div").find("span").text(data.str);
                        $(this)
                            .closest("div")
                            .find(".update_value")
                            .val(data.str);
                    });
                    initExTableFilter();
                    showToast("処理が成功しました", "success", 3000);
                } else {
                    showToast("エラーが発生しました", "danger", 3000);
                }
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                showToast("エラーが発生しました", "danger", 3000);
            });
    });
    $("#col_check_po").on("change", function () {
        let checked = $(this).prop("checked");
        $('input[name="col_po[]"]:visible').each(function () {
            $(this).prop("checked", checked);
        });
    });
    //invoice更新
    $("#do_action_invoice").on("click", function () {
        let ids = $('input[name="col_invoice[]"]:checked')
            .map(function () {
                return $(this).val();
            })
            .get();
        //console.log(ids);
        if (ids.length === 0) {
            showToast("1つ以上選択してください", "danger"); // トースト表示
            return; // 処理を中断
        }
        let input_txt = $("#input_invoice").val();
        //console.log(input_txt);
        if (input_txt == "") {
            showToast("値を入力してください", "danger"); // トースト表示
            return; // 処理を中断
        }
        $.ajax({
            url: "/ajax/do_action_invoice/",
            type: "GET",
            dataType: "json",
            data: {
                ids: ids,
                str: input_txt,
            },
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
        })
            .done((data) => {
                if (data.status) {
                    $('input[name="col_invoice[]"]:checked').each(function () {
                        $(this).closest("div").find("span").text(data.str);
                        $(this)
                            .closest("div")
                            .find(".update_value")
                            .val(data.str);
                    });
                    initExTableFilter();
                    showToast("処理が成功しました", "success", 3000);
                } else {
                    showToast("エラーが発生しました", "danger", 3000);
                }
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                showToast("エラーが発生しました", "danger", 3000);
            });
    });
    $("#col_check_invoice").on("change", function () {
        let checked = $(this).prop("checked");
        $('input[name="col_invoice[]"]:visible').each(function () {
            $(this).prop("checked", checked);
        });
    });
    //サプライヤ更新
    $("#do_action_supplier").on("click", function () {
        let ids = $('input[name="col_supplier[]"]:checked')
            .map(function () {
                return $(this).val();
            })
            .get();
        //console.log(ids);
        if (ids.length === 0) {
            showToast("1つ以上選択してください", "danger"); // トースト表示
            return; // 処理を中断
        }
        let supplier_id = $("#supplier_id").val();
        //console.log(supplier_id);
        $.ajax({
            url: "/ajax/do_action_supplier/",
            type: "GET",
            dataType: "json",
            data: {
                ids: ids,
                supplier_id: supplier_id,
            },
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
        })
            .done((data) => {
                if (data.status) {
                    $('input[name="col_supplier[]"]:checked').each(function () {
                        $(this)
                            .closest("div")
                            .find("span")
                            .text(data.supplier_name);
                        $(this)
                            .closest("div")
                            .find(".update_value")
                            .val(data.supplier_id);
                    });
                    initExTableFilter();
                    showToast("処理が成功しました", "success", 3000);
                } else {
                    showToast("エラーが発生しました", "danger", 3000);
                }
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                showToast("エラーが発生しました", "danger", 3000);
            });
    });
    $("#col_check_supplier").on("change", function () {
        let checked = $(this).prop("checked");
        $('input[name="col_supplier[]"]:visible').each(function () {
            $(this).prop("checked", checked);
        });
    });
    //SHIP/AIR更新
    $("#do_action_ship").on("click", function () {
        let ids = $('input[name="col_ship[]"]:checked')
            .map(function () {
                return $(this).val();
            })
            .get();
        //console.log(ids);
        if (ids.length === 0) {
            showToast("1つ以上選択してください", "danger"); // トースト表示
            return; // 処理を中断
        }
        let ship_id = $("#ship_id").val();
        //console.log(ship_id);
        $.ajax({
            url: "/ajax/do_action_ship/",
            type: "GET",
            dataType: "json",
            data: {
                ids: ids,
                ship_id: ship_id,
            },
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
        })
            .done((data) => {
                if (data.status) {
                    $('input[name="col_ship[]"]:checked').each(function () {
                        $(this)
                            .closest("div")
                            .find("span")
                            .text(data.ship_name);
                        $(this)
                            .closest("div")
                            .find(".update_value")
                            .val(data.ship_id);
                        $(this)
                            .closest("tr")
                            .find(".col_syukkoubi")
                            .text(data.syukkoubi);
                        $(this)
                            .closest("tr")
                            .find(".col_nyuukoubi")
                            .text(data.nyuukoubi);
                    });
                    initExTableFilter();
                    showToast("処理が成功しました", "success", 3000);
                } else {
                    showToast("エラーが発生しました", "danger", 3000);
                }
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                showToast("エラーが発生しました", "danger", 3000);
            });
    });
    $("#col_check_ship").on("change", function () {
        let checked = $(this).prop("checked");
        $('input[name="col_ship[]"]:visible').each(function () {
            $(this).prop("checked", checked);
        });
    });
    //納品更新
    $("#do_action_delivery").on("click", function () {
        let ids = $('input[name="col_delivery[]"]:checked')
            .map(function () {
                return $(this).val();
            })
            .get();
        //console.log(ids);
        if (ids.length === 0) {
            showToast("1つ以上選択してください", "danger"); // トースト表示
            return; // 処理を中断
        }
        let delivery_id = $("#delivery_id").val();
        //console.log(ship_id);
        $.ajax({
            url: "/ajax/do_action_delivery/",
            type: "GET",
            dataType: "json",
            data: {
                ids: ids,
                delivery_id: delivery_id,
            },
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
        })
            .done((data) => {
                if (data.status) {
                    $('input[name="col_delivery[]"]:checked').each(function () {
                        $(this)
                            .closest("div")
                            .find("span")
                            .text(data.delivery_date);
                        $(this)
                            .closest("tr")
                            .find(".col_delivery_date")
                            .text(data.delivery_date);
                    });
                    initExTableFilter();
                    showToast("処理が成功しました", "success", 3000);
                } else {
                    showToast("エラーが発生しました", "danger", 3000);
                }
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                showToast("エラーが発生しました", "danger", 3000);
            });
    });
    $("#col_check_delivery").on("change", function () {
        let checked = $(this).prop("checked");
        $('input[name="col_delivery[]"]:visible').each(function () {
            $(this).prop("checked", checked);
        });
    });
    //製造完了日更新
    $("#do_action_product_complete").on("click", function () {
        let ids = $('input[name="col_product_complete[]"]:checked')
            .map(function () {
                return $(this).val();
            })
            .get();
        //console.log(ids);
        if (ids.length === 0) {
            showToast("1つ以上選択してください", "danger"); // トースト表示
            return; // 処理を中断
        }
        let input_txt = $("#input_product_complete").val();
        //console.log(input_txt);
        if (input_txt == "") {
            showToast("値を入力してください", "danger"); // トースト表示
            return; // 処理を中断
        }
        let regex = /^\d{4}$/;
        if (!regex.test(input_txt)) {
            showToast("「YYWW」の形式で入力してください", "danger", 3000);
            return;
        }
        $.ajax({
            url: "/ajax/do_action_product_complete/",
            type: "GET",
            dataType: "json",
            data: {
                ids: ids,
                str: input_txt,
            },
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
        })
            .done((data) => {
                if (data.status) {
                    $('input[name="col_product_complete[]"]:checked').each(
                        function () {
                            $(this).closest("div").find("span").text(data.yyww);
                            $(this)
                                .closest("div")
                                .find(".update_value")
                                .val(data.yyww);
                            $(this)
                                .closest("tr")
                                .find(".col_product_complete_date")
                                .text(data.ymd);
                        }
                    );
                    initExTableFilter();
                    showToast("処理が成功しました", "success", 3000);
                } else {
                    showToast("エラーが発生しました", "danger", 3000);
                }
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                showToast("エラーが発生しました", "danger", 3000);
            });
    });
    $("#col_check_product_complete").on("change", function () {
        let checked = $(this).prop("checked");
        $('input[name="col_product_complete[]"]:visible').each(function () {
            $(this).prop("checked", checked);
        });
    });
    //納品日更新
    $("#do_action_nouhinbi").on("click", function () {
        let ids = $('input[name="col_nouhinbi[]"]:checked')
            .map(function () {
                return $(this).val();
            })
            .get();
        //console.log(ids);
        if (ids.length === 0) {
            showToast("1つ以上選択してください", "danger"); // トースト表示
            return; // 処理を中断
        }
        let input_txt = $("#input_nouhinbi").val();
        //console.log(input_txt);
        if (input_txt == "") {
            showToast("値を入力してください", "danger"); // トースト表示
            return; // 処理を中断
        }
        let regex = /^\d{2}\/\d{2}\/\d{2}$/;
        if (!regex.test(input_txt)) {
            showToast("「YY/MM/DD」の形式で入力してください", "danger", 3000);
            return;
        }
        $.ajax({
            url: "/ajax/do_action_nouhinbi/",
            type: "GET",
            dataType: "json",
            data: {
                ids: ids,
                str: input_txt,
            },
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
        })
            .done((data) => {
                if (data.status) {
                    $('input[name="col_nouhinbi[]"]:checked').each(function () {
                        $(this).closest("div").find("span").text(data.date);
                        $(this)
                            .closest("div")
                            .find(".update_value")
                            .val(data.date);
                    });
                    initExTableFilter();
                    showToast("処理が成功しました", "success", 3000);
                } else {
                    showToast("エラーが発生しました", "danger", 3000);
                }
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                showToast("エラーが発生しました", "danger", 3000);
            });
    });
    $("#col_check_nouhinbi").on("change", function () {
        let checked = $(this).prop("checked");
        $('input[name="col_nouhinbi[]"]:visible').each(function () {
            $(this).prop("checked", checked);
        });
    });

    //SHIP/AIR登録
    $("#do_action_regist_ship").on("click", function () {
        $(this).prop("disabled", true);

        // form 内の input値をまとめて取得
        let formData = {};
        hasEmpty = false;

        $("#shipModal .modal-body input[type=text]").each(function () {
            let name = $(this).attr("name");
            let value = $(this).val();
            formData[name] = value;
            // 必須は SHIPNo.・FWD・通関業者・出航日・入港日だけ（SHIP-AIR新規登録画面と同じ）。
            // トラッキング・金額の欄は任意
            let required = ["ship[name]", "ship[fwd]", "ship[company]", "ship[syukkoubi]", "ship[nyuukoubi]"];
            if (value == "" && required.includes(name) && !hasEmpty) {
                hasEmpty = true;
                firstEmptyField = this;
            }
        });
        //console.log(formData);
        // 空欄チェック
        if (hasEmpty) {
            showToast(
                "未入力の項目があります。SHIPNo.・FWD・通関業者・出航日・入港日を入力してください。",
                "danger"
            );
            $(firstEmptyField).focus();
            return; // Ajax送信しない
        }
        $.ajax({
            url: "/ajax/do_action_regist_ship", //送信先URLに変更
            type: "GET",
            data: formData,
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
            dataType: "json",
        })
            .done((data) => {
                //console.log(data);
                if (data.status) {
                    $("#shipModal").modal("hide");
                    $(".ship_id").append(
                        '<option value="' +
                            data.id +
                            '">' +
                            data.name +
                            "</option>"
                    );
                    $(this).prop("disabled", false);
                    showToast("処理が成功しました", "success", 3000);
                } else {
                    showToast("エラーが発生しました", "danger", 3000);
                }
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                showToast("エラーが発生しました", "danger", 3000);
            });
    });

    //納品登録
    $("#do_action_regist_delivery").on("click", function () {
        console.log("ok");

        $(this).prop("disabled", true);

        // form 内の input値をまとめて取得
        let formData = {};
        hasEmpty = false;

        $("#deliveryModal .modal-body input[type=text]").each(function () {
            let name = $(this).attr("name");
            let value = $(this).val();
            formData[name] = value;
            if (value == "") {
                hasEmpty = true;
                firstEmptyField = this;
                return false;
            }
        });
        //console.log(formData);
        // 空欄チェック
        if (hasEmpty) {
            showToast(
                "未入力の項目があります。すべて入力してください。",
                "danger"
            );
            $(firstEmptyField).focus();
            return; // Ajax送信しない
        }
        $.ajax({
            url: "/ajax/do_action_regist_delivery", //送信先URLに変更
            type: "GET",
            data: formData,
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
            dataType: "json",
        })
            .done((data) => {
                //console.log(data);
                if (data.status) {
                    $("#deliveryModal").modal("hide");
                    $(".delivery_id").append(
                        '<option value="' +
                            data.id +
                            '">' +
                            data.name +
                            "</option>"
                    );
                    $(this).prop("disabled", false);
                    showToast("処理が成功しました", "success", 3000);
                } else {
                    showToast("エラーが発生しました", "danger", 3000);
                }
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                showToast("エラーが発生しました", "danger", 3000);
            });
    });

    //受注price登録編集
    $(".order_receive_price").on("change", function () {
        let id = $(this).data("id");
        let price = $(this).val();

        if (!/^[0-9.,]*$/.test(price)) {
            showToast(
                "半角数字とピリオド「.」のみ入力できます",
                "danger",
                3000
            );
            return;
        }

        $.ajax({
            url: "/ajax/do_action_order_receive_price/",
            type: "GET",
            dataType: "json",
            data: {
                id: id,
                price: price,
            },
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
        })
            .done((data) => {
                if (data.status) {
                    $(this).next("span").text(data.price);
                    initExTableFilter();
                    showToast("処理が成功しました", "success", 3000);
                } else {
                    showToast("エラーが発生しました", "danger", 3000);
                }
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                showToast("エラーが発生しました", "danger", 3000);
            });
    });

    //個別更新
    $(".update_value").on("change", function () {
        let id = $(this).data("id");
        let target = $(this).data("target");
        let value = $(this).val();

        //if (!/^[0-9.,]*$/.test(value)) {
        //    showToast("半角数字とピリオド「.」のみ入力できます", "danger", 3000);
        //    return;
        //}

        //alert(id+':'+target+'='+value);
        //return false;

        $.ajax({
            url: "/ajax/do_update_value/",
            type: "GET",
            dataType: "json",
            data: {
                id: id,
                target: target,
                value: value,
            },
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
        })
            .done((data) => {
                if (data.status) {
                    $(this).next("span").text(data.value);
                    if (target == "product_complete_date") {
                        $(this)
                            .closest("tr")
                            .find(".col_product_complete_date")
                            .text(data.ymd);
                    }
                    if (target == "ship_id") {
                        $(this)
                            .closest("tr")
                            .find(".col_syukkoubi")
                            .text(data.syukkoubi);
                        $(this)
                            .closest("tr")
                            .find(".col_nyuukoubi")
                            .text(data.nyuukoubi);
                    }

                    initExTableFilter();
                    showToast("処理が成功しました", "success", 3000);
                } else {
                    showToast("エラーが発生しました", "danger", 3000);
                }
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                showToast("エラーが発生しました", "danger", 3000);
            });
    });

    //初回、納品済みを非表示
    $(`.filter7 input`).each(function () {
        if ($(this).val() !== "納品済み") {
            $(this).prop("checked", true);
        }
    });
    //発火
    $(`.filter7 input:first`).trigger("change");

    displayColmun();
}

if ($("#order_table2").length > 0) {
    //120日アラート対応ボタン
    $(".do_action1").on("click", function () {
        let q_id = $(this).data("qpid");
        $.ajax({
            url: "/ajax/doaction1/" + q_id,
            type: "GET",
            dataType: "json",
        })
            .done((data) => {
                if (data.status) {
                    showToast("処理が成功しました", "success", 3000);
                    $('[data-qid="q_' + q_id + '"]')
                        .find(".col-alert")
                        .html("");
                    initExTableFilter();
                } else {
                    showToast("エラーが発生しました", "danger", 3000);
                }
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                showToast("エラーが発生しました", "danger", 3000);
            });
    });
    //240日アラート対応ボタン
    $(".do_action2").on("click", function () {
        let q_id = $(this).data("qpid");
        $.ajax({
            url: "/ajax/doaction2/" + q_id,
            type: "GET",
            dataType: "json",
        })
            .done((data) => {
                if (data.status) {
                    showToast("処理が成功しました", "success", 3000);
                    $('[data-qid="q_' + q_id + '"]')
                        .find(".col-alert")
                        .html("");
                    initExTableFilter();
                } else {
                    showToast("エラーが発生しました", "danger", 3000);
                }
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                showToast("エラーが発生しました", "danger", 3000);
            });
    });
    //PO更新
    $("#do_action_po").on("click", function () {
        let ids = $('input[name="col_po[]"]:checked')
            .map(function () {
                return $(this).val();
            })
            .get();
        //console.log(ids);
        if (ids.length === 0) {
            showToast("1つ以上選択してください", "danger"); // トースト表示
            return; // 処理を中断
        }
        let input_txt = $("#input_po").val();
        //console.log(input_txt);
        if (input_txt == "") {
            showToast("値を入力してください", "danger"); // トースト表示
            return; // 処理を中断
        }
        $.ajax({
            url: "/ajax/do_action_po/",
            type: "GET",
            dataType: "json",
            data: {
                ids: ids,
                str: input_txt,
            },
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
        })
            .done((data) => {
                if (data.status) {
                    $('input[name="col_po[]"]:checked').each(function () {
                        $(this).closest("div").find("span").text(data.str);
                        $(this)
                            .closest("div")
                            .find(".update_value")
                            .val(data.str);
                    });
                    initExTableFilter();
                    showToast("処理が成功しました", "success", 3000);
                } else {
                    showToast("エラーが発生しました", "danger", 3000);
                }
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                showToast("エラーが発生しました", "danger", 3000);
            });
    });
    $("#col_check_po").on("change", function () {
        let checked = $(this).prop("checked");
        $('input[name="col_po[]"]:visible').each(function () {
            $(this).prop("checked", checked);
        });
    });
    //invoice更新
    $("#do_action_invoice").on("click", function () {
        let ids = $('input[name="col_invoice[]"]:checked')
            .map(function () {
                return $(this).val();
            })
            .get();
        //console.log(ids);
        if (ids.length === 0) {
            showToast("1つ以上選択してください", "danger"); // トースト表示
            return; // 処理を中断
        }
        let input_txt = $("#input_invoice").val();
        //console.log(input_txt);
        if (input_txt == "") {
            showToast("値を入力してください", "danger"); // トースト表示
            return; // 処理を中断
        }
        $.ajax({
            url: "/ajax/do_action_invoice/",
            type: "GET",
            dataType: "json",
            data: {
                ids: ids,
                str: input_txt,
            },
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
        })
            .done((data) => {
                if (data.status) {
                    $('input[name="col_invoice[]"]:checked').each(function () {
                        $(this).closest("div").find("span").text(data.str);
                        $(this)
                            .closest("div")
                            .find(".update_value")
                            .val(data.str);
                    });
                    initExTableFilter();
                    showToast("処理が成功しました", "success", 3000);
                } else {
                    showToast("エラーが発生しました", "danger", 3000);
                }
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                showToast("エラーが発生しました", "danger", 3000);
            });
    });
    $("#col_check_invoice").on("change", function () {
        let checked = $(this).prop("checked");
        $('input[name="col_invoice[]"]:visible').each(function () {
            $(this).prop("checked", checked);
        });
    });
    //サプライヤ更新
    $("#do_action_supplier").on("click", function () {
        let ids = $('input[name="col_supplier[]"]:checked')
            .map(function () {
                return $(this).val();
            })
            .get();
        //console.log(ids);
        if (ids.length === 0) {
            showToast("1つ以上選択してください", "danger"); // トースト表示
            return; // 処理を中断
        }
        let supplier_id = $("#supplier_id").val();
        //console.log(supplier_id);
        $.ajax({
            url: "/ajax/do_action_supplier/",
            type: "GET",
            dataType: "json",
            data: {
                ids: ids,
                supplier_id: supplier_id,
            },
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
        })
            .done((data) => {
                if (data.status) {
                    $('input[name="col_supplier[]"]:checked').each(function () {
                        $(this)
                            .closest("div")
                            .find("span")
                            .text(data.supplier_name);
                        $(this)
                            .closest("div")
                            .find(".update_value")
                            .val(data.supplier_id);
                    });
                    initExTableFilter();
                    showToast("処理が成功しました", "success", 3000);
                } else {
                    showToast("エラーが発生しました", "danger", 3000);
                }
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                showToast("エラーが発生しました", "danger", 3000);
            });
    });
    $("#col_check_supplier").on("change", function () {
        let checked = $(this).prop("checked");
        $('input[name="col_supplier[]"]:visible').each(function () {
            $(this).prop("checked", checked);
        });
    });
    //SHIP/AIR更新
    $("#do_action_ship").on("click", function () {
        let ids = $('input[name="col_ship[]"]:checked')
            .map(function () {
                return $(this).val();
            })
            .get();
        //console.log(ids);
        if (ids.length === 0) {
            showToast("1つ以上選択してください", "danger"); // トースト表示
            return; // 処理を中断
        }
        let ship_id = $("#ship_id").val();
        //console.log(ship_id);
        $.ajax({
            url: "/ajax/do_action_ship/",
            type: "GET",
            dataType: "json",
            data: {
                ids: ids,
                ship_id: ship_id,
            },
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
        })
            .done((data) => {
                if (data.status) {
                    $('input[name="col_ship[]"]:checked').each(function () {
                        $(this)
                            .closest("div")
                            .find("span")
                            .text(data.ship_name);
                        $(this)
                            .closest("div")
                            .find(".update_value")
                            .val(data.ship_id);
                        $(this)
                            .closest("tr")
                            .find(".col_syukkoubi")
                            .text(data.syukkoubi);
                        $(this)
                            .closest("tr")
                            .find(".col_nyuukoubi")
                            .text(data.nyuukoubi);
                    });
                    initExTableFilter();
                    showToast("処理が成功しました", "success", 3000);
                } else {
                    showToast("エラーが発生しました", "danger", 3000);
                }
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                showToast("エラーが発生しました", "danger", 3000);
            });
    });
    $("#col_check_ship").on("change", function () {
        let checked = $(this).prop("checked");
        $('input[name="col_ship[]"]:visible').each(function () {
            $(this).prop("checked", checked);
        });
    });
    //納品更新
    $("#do_action_delivery").on("click", function () {
        let ids = $('input[name="col_delivery[]"]:checked')
            .map(function () {
                return $(this).val();
            })
            .get();
        //console.log(ids);
        if (ids.length === 0) {
            showToast("1つ以上選択してください", "danger"); // トースト表示
            return; // 処理を中断
        }
        let delivery_id = $("#delivery_id").val();
        //console.log(ship_id);
        $.ajax({
            url: "/ajax/do_action_delivery/",
            type: "GET",
            dataType: "json",
            data: {
                ids: ids,
                delivery_id: delivery_id,
            },
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
        })
            .done((data) => {
                if (data.status) {
                    $('input[name="col_delivery[]"]:checked').each(function () {
                        $(this)
                            .closest("div")
                            .find("span")
                            .text(data.delivery_date);
                        $(this)
                            .closest("div")
                            .find(".update_value")
                            .val(data.delivery_id);
                        $(this)
                            .closest("tr")
                            .find(".col_delivery_date")
                            .text(data.delivery_date);
                    });
                    initExTableFilter();
                    showToast("処理が成功しました", "success", 3000);
                } else {
                    showToast("エラーが発生しました", "danger", 3000);
                }
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                showToast("エラーが発生しました", "danger", 3000);
            });
    });
    $("#col_check_delivery").on("change", function () {
        let checked = $(this).prop("checked");
        $('input[name="col_delivery[]"]:visible').each(function () {
            $(this).prop("checked", checked);
        });
    });
    //製造完了日更新
    $("#do_action_product_complete").on("click", function () {
        let ids = $('input[name="col_product_complete[]"]:checked')
            .map(function () {
                return $(this).val();
            })
            .get();
        //console.log(ids);
        if (ids.length === 0) {
            showToast("1つ以上選択してください", "danger"); // トースト表示
            return; // 処理を中断
        }
        let input_txt = $("#input_product_complete").val();
        //console.log(input_txt);
        if (input_txt == "") {
            showToast("値を入力してください", "danger"); // トースト表示
            return; // 処理を中断
        }
        let regex = /^\d{4}$/;
        if (!regex.test(input_txt)) {
            showToast("「YYWW」の形式で入力してください", "danger", 3000);
            return;
        }
        $.ajax({
            url: "/ajax/do_action_product_complete/",
            type: "GET",
            dataType: "json",
            data: {
                ids: ids,
                str: input_txt,
            },
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
        })
            .done((data) => {
                if (data.status) {
                    $('input[name="col_product_complete[]"]:checked').each(
                        function () {
                            $(this).closest("div").find("span").text(data.yyww);
                            $(this)
                                .closest("div")
                                .find(".update_value")
                                .val(data.yyww);
                            $(this)
                                .closest("tr")
                                .find(".col_product_complete_date")
                                .text(data.ymd);
                        }
                    );
                    initExTableFilter();
                    showToast("処理が成功しました", "success", 3000);
                } else {
                    showToast("エラーが発生しました", "danger", 3000);
                }
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                showToast("エラーが発生しました", "danger", 3000);
            });
    });
    $("#col_check_product_complete").on("change", function () {
        let checked = $(this).prop("checked");
        $('input[name="col_product_complete[]"]:visible').each(function () {
            $(this).prop("checked", checked);
        });
    });
    //納品日更新
    $("#do_action_nouhinbi").on("click", function () {
        let ids = $('input[name="col_nouhinbi[]"]:checked')
            .map(function () {
                return $(this).val();
            })
            .get();
        //console.log(ids);
        if (ids.length === 0) {
            showToast("1つ以上選択してください", "danger"); // トースト表示
            return; // 処理を中断
        }
        let input_txt = $("#input_nouhinbi").val();
        //console.log(input_txt);
        if (input_txt == "") {
            showToast("値を入力してください", "danger"); // トースト表示
            return; // 処理を中断
        }
        let regex = /^\d{2}\/\d{2}\/\d{2}$/;
        if (!regex.test(input_txt)) {
            showToast("「YY/MM/DD」の形式で入力してください", "danger", 3000);
            return;
        }
        $.ajax({
            url: "/ajax/do_action_nouhinbi/",
            type: "GET",
            dataType: "json",
            data: {
                ids: ids,
                str: input_txt,
            },
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
        })
            .done((data) => {
                if (data.status) {
                    $('input[name="col_nouhinbi[]"]:checked').each(function () {
                        $(this).closest("div").find("span").text(data.date);
                        $(this)
                            .closest("div")
                            .find(".update_value")
                            .val(data.date);
                    });
                    initExTableFilter();
                    showToast("処理が成功しました", "success", 3000);
                } else {
                    showToast("エラーが発生しました", "danger", 3000);
                }
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                showToast("エラーが発生しました", "danger", 3000);
            });
    });
    $("#col_check_nouhinbi").on("change", function () {
        let checked = $(this).prop("checked");
        $('input[name="col_nouhinbi[]"]:visible').each(function () {
            $(this).prop("checked", checked);
        });
    });
    //イベント更新
    $("#do_action_event").on("click", function () {
        let ids = $('input[name="col_event[]"]:checked')
            .map(function () {
                return $(this).val();
            })
            .get();
        //console.log(ids);
        if (ids.length === 0) {
            showToast("1つ以上選択してください", "danger"); // トースト表示
            return; // 処理を中断
        }
        let event_id = $("#event_id").val();
        //console.log(ship_id);
        $.ajax({
            url: "/ajax/do_action_event/",
            type: "GET",
            dataType: "json",
            data: {
                ids: ids,
                event_id: event_id,
            },
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
        })
            .done((data) => {
                if (data.status) {
                    $('input[name="col_event[]"]:checked').each(function () {
                        if (
                            $(this)
                                .closest("div")
                                .find("span")
                                .find("#event-" + data.event_id).length == 0
                        ) {
                            $(this)
                                .closest("div")
                                .find("span")
                                .append(
                                    '<span id="event-' +
                                        data.event_id +
                                        '" data-id="' +
                                        data.event_id +
                                        '">' +
                                        data.name +
                                        '<button type="button" class="btn-close"></button></span>'
                                );
                        }
                    });
                    initExTableFilter();
                    showToast("処理が成功しました", "success", 3000);
                } else {
                    showToast("エラーが発生しました", "danger", 3000);
                }
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                showToast("エラーが発生しました", "danger", 3000);
            });
    });
    $("#col_check_event").on("change", function () {
        let checked = $(this).prop("checked");
        $('input[name="col_event[]"]:visible').each(function () {
            $(this).prop("checked", checked);
        });
    });
    $(document).on("click", ".event_wrap .btn-close", function () {
        var quotation_product_id = $(this).parents(".event_wrap").data("id");
        var event_id = $(this).parent("span").data("id");

        $.ajax({
            url: "/ajax/do_action_event_delete/",
            type: "GET",
            dataType: "json",
            data: {
                quotation_product_id: quotation_product_id,
                event_id: event_id,
            },
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
        })
            .done((data) => {
                if (data.status) {
                    $(this).parent("span").remove();
                    showToast("イベントを削除しました", "success", 3000);
                } else {
                    showToast("エラーが発生しました", "danger", 3000);
                }
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                showToast("エラーが発生しました", "danger", 3000);
            });
    });

    //SHIP/AIR登録
    $("#do_action_regist_ship").on("click", function () {
        $(this).prop("disabled", true);

        // form 内の input値をまとめて取得
        let formData = {};
        hasEmpty = false;

        $("#shipModal .modal-body input[type=text],#shipModal .modal-body input[type=number]").each(function () {
            let name = $(this).attr("name");
            let value = $(this).val();
            formData[name] = value;
            // 必須は SHIPNo.・FWD・通関業者・出航日・入港日だけ（SHIP-AIR新規登録画面と同じ）。
            // トラッキング・金額の欄は任意
            let required = ["ship[name]", "ship[fwd]", "ship[company]", "ship[syukkoubi]", "ship[nyuukoubi]"];
            if (value == "" && required.includes(name) && !hasEmpty) {
                hasEmpty = true;
                firstEmptyField = this;
            }
        });
        //console.log(formData);
        // 空欄チェック
        if (hasEmpty) {
            showToast(
                "未入力の項目があります。SHIPNo.・FWD・通関業者・出航日・入港日を入力してください。",
                "danger"
            );
            $(firstEmptyField).focus();
            $(this).prop("disabled", false);
            return; // Ajax送信しない
        }
        // 入力できない値（整数の欄の小数など）は、新規登録画面と同じくブラウザの表示で止める
        let invalidField = $("#shipModal .modal-body input").toArray().find((e) => !e.checkValidity());
        if (invalidField) {
            invalidField.reportValidity();
            $(this).prop("disabled", false);
            return;
        }
        $.ajax({
            url: "/ajax/do_action_regist_ship", //送信先URLに変更
            type: "GET",
            data: formData,
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
            dataType: "json",
        })
            .done((data) => {
                //console.log(data);
                if (data.status) {
                    $("#shipModal").modal("hide");
                    $(".ship_id").append(
                        '<option value="' +
                            data.id +
                            '">' +
                            data.name +
                            "</option>"
                    );
                    $(this).prop("disabled", false);
                    showToast("処理が成功しました", "success", 3000);
                } else {
                    showToast("エラーが発生しました", "danger", 3000);
                }
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                showToast("エラーが発生しました", "danger", 3000);
            });
    });

    //納品登録
    $("#do_action_regist_delivery").on("click", function () {
        $(this).prop("disabled", true);

        // form 内の input値をまとめて取得
        let formData = {};
        hasEmpty = false;

        $("#deliveryModal .modal-body input[type=text]").each(function () {
            let name = $(this).attr("name");
            let value = $(this).val();
            formData[name] = value;
            if (value == "") {
                hasEmpty = true;
                firstEmptyField = this;
                return false;
            }
        });
        formData["delivery[delivery_id]"] = $(
            "#deliveryModal .modal-body select"
        ).val();
        formData["delivery[delivery_note]"] = $(
            "#deliveryModal .modal-body textarea"
        ).val();

        console.log(formData);
        // 空欄チェック
        if (hasEmpty) {
            showToast(
                "未入力の項目があります。すべて入力してください。",
                "danger"
            );
            $(firstEmptyField).focus();
            $(this).prop("disabled", false);
            return; // Ajax送信しない
        }
        $.ajax({
            url: "/ajax/do_action_regist_delivery", //送信先URLに変更
            type: "GET",
            data: formData,
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
            dataType: "json",
        })
            .done((data) => {
                //console.log(data);
                if (data.status) {
                    $("#deliveryModal").modal("hide");
                    $(".delivery_id").append(
                        '<option value="' +
                            data.id +
                            '">' +
                            data.name +
                            "</option>"
                    );
                    $(this).prop("disabled", false);
                    showToast("処理が成功しました", "success", 3000);
                } else {
                    showToast("エラーが発生しました", "danger", 3000);
                }
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                showToast("エラーが発生しました", "danger", 3000);
                $(this).prop("disabled", false);
            });
    });

    //イベント登録
    $("#do_action_regist_event").on("click", function () {
        $(this).prop("disabled", true);

        // form 内の input値をまとめて取得
        let formData = {};
        hasEmpty = false;

        $("#eventModal .modal-body input[type=text]").each(function () {
            let name = $(this).attr("name");
            let value = $(this).val();
            formData[name] = value;
            if (value == "") {
                hasEmpty = true;
                firstEmptyField = this;
                return false;
            }
        });
        formData["event[event_type_id]"] = $(
            "#eventModal .modal-body input[type=radio]:checked"
        ).val();
        formData["event[event_note]"] = $(
            "#eventModal .modal-body textarea"
        ).val();

        console.log(formData);
        // 空欄チェック
        if (hasEmpty) {
            showToast(
                "未入力の項目があります。すべて入力してください。",
                "danger"
            );
            $(firstEmptyField).focus();
            $(this).prop("disabled", false);
            return; // Ajax送信しない
        }
        $.ajax({
            url: "/ajax/do_action_regist_event", //送信先URLに変更
            type: "GET",
            data: formData,
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
            dataType: "json",
        })
            .done((data) => {
                //console.log(data);
                if (data.status) {
                    $("#eventModal").modal("hide");
                    $("#event_id").append(
                        '<option value="' +
                            data.id +
                            '">' +
                            data.name +
                            "</option>"
                    );
                    $(this).prop("disabled", false);
                    showToast("処理が成功しました", "success", 3000);
                } else {
                    $(this).prop("disabled", false);
                    showToast("エラーが発生しました", "danger", 3000);
                }
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                $(this).prop("disabled", false);
                showToast("エラーが発生しました", "danger", 3000);
            });
    });

    //受注price登録編集
    $(".order_receive_price").on("change", function () {
        let id = $(this).data("id");
        let price = $(this).val();

        if (!/^[0-9.,]*$/.test(price)) {
            showToast(
                "半角数字とピリオド「.」のみ入力できます",
                "danger",
                3000
            );
            return;
        }

        $.ajax({
            url: "/ajax/do_action_order_receive_price/",
            type: "GET",
            dataType: "json",
            data: {
                id: id,
                price: price,
            },
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
        })
            .done((data) => {
                if (data.status) {
                    $(this).next("span").text(data.price);
                    initExTableFilter();
                    showToast("処理が成功しました", "success", 3000);
                } else {
                    showToast("エラーが発生しました", "danger", 3000);
                }
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                showToast("エラーが発生しました", "danger", 3000);
            });
    });

    //個別更新
    $(".update_value").on("change", function () {
        let id = $(this).data("id");
        let target = $(this).data("target");
        let value = $(this).val();

        //if (!/^[0-9.,]*$/.test(value)) {
        //    showToast("半角数字とピリオド「.」のみ入力できます", "danger", 3000);
        //    return;
        //}

        //alert(id+':'+target+'='+value);
        //return false;

        $.ajax({
            url: "/ajax/do_update_value/",
            type: "GET",
            dataType: "json",
            data: {
                id: id,
                target: target,
                value: value,
            },
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
        })
            .done((data) => {
                console.log(data);
                if (data.status) {
                    $(this).next("span").text(data.value);
                    if (target == "product_complete_date") {
                        $(this)
                            .closest("tr")
                            .find(".col_product_complete_date")
                            .text(data.ymd);
                    }
                    if (target == "ship_id") {
                        $(this)
                            .closest("tr")
                            .find(".col_syukkoubi")
                            .text(data.syukkoubi);
                        $(this)
                            .closest("tr")
                            .find(".col_nyuukoubi")
                            .text(data.nyuukoubi);
                    }
                    if (target == "delivery_id") {
                        $(this)
                            .closest("tr")
                            .find(".col_delivery_date")
                            .text(data.delivery_date);
                    }

                    initExTableFilter();
                    showToast("処理が成功しました", "success", 3000);
                } else {
                    showToast("エラーが発生しました", "danger", 3000);
                }
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                showToast("エラーが発生しました", "danger", 3000);
            });
    });

    // --- 列フィルター（受注No.・顧客名・ステータスなど、見出しに .col-filter がある列） ---
    $(document).on("change", "#order_table2 .col-filter input", applyOrderTable2Filter);

    $(document).on("click", "#order_table2 .col-filter .clear-col-filter", function () {
        $(this).closest(".col-filter").find("input").prop("checked", false);
        applyOrderTable2Filter();
    });

    buildOrderTable2Filter();
    displayColmun2();
}

// SHIP-AIR の仕入書価格¥（€ × レート）・税抜額（請求額 − 税）・SHIP-AIR / 仕入れ％ の自動計算
// 受注一覧 Ver.2 の SHIP-AIR新規登録（モーダル）と、SHIP-AIR の新規作成・編集画面で使う
// どの欄を変えても 3 つとも計算し直す（€・レートをあとから変えたときも仕入れ％を合わせる）
if ($("#invoice_price").length > 0) {
    function calcShipFreightRatio() {
        if ($("#ex_tax").val() > 0 && $("#invoice_price_yen").val() > 0) {
            let freight_ratio = Math.round(($("#ex_tax").val() / $("#invoice_price_yen").val()) * 10000) / 100;
            $("#freight_ratio").val(freight_ratio);
        }
    }
    function calcShip() {
        if ($("#invoice_price").val() > 0 && $("#euro_to_yen").val() > 0) {
            let price_yen = Math.round($("#invoice_price").val() * $("#euro_to_yen").val());
            $("#invoice_price_yen").val(price_yen);
        }
        if ($("#billed_amount").val() > 0) {
            let total_tax = 0;
            $(".tax").each(function () {
                if ($(this).val() > 0) {
                    total_tax += 1 * $(this).val();
                }
            });
            $("#ex_tax").val($("#billed_amount").val() * 1 - total_tax);
        }
        calcShipFreightRatio();
    }
    $("#invoice_price,#euro_to_yen,#billed_amount,.tax").on("input", calcShip);
}

// index3 のセルの値（入力欄・プルダウンは非表示の span に値を写しているので除いて読む）
// セルを複製すると行数が多いとき遅いため、プルダウンの中以外の文字を直接つなげる
function orderTable2CellValue(td) {
    td = td.jquery ? td[0] : td;
    if (!td) return "";
    let text = "";
    // プルダウン（選択肢の文字）は中をたどらずに飛ばす
    const walker = document.createTreeWalker(td, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT, {
        acceptNode: (node) =>
            node.nodeName === "SELECT" ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT,
    });
    while (walker.nextNode()) {
        if (walker.currentNode.nodeType === Node.TEXT_NODE) text += walker.currentNode.nodeValue;
    }
    return text.replace(/\s+/g, " ").trim();
}

// index3 の列フィルターの選択肢を作る（選択中のチェックは残す）
function buildOrderTable2Filter() {
    $("#order_table2 .col-filter").each(function () {
        let container = $(this);
        let col = container.data("col");
        let checked = container.find("input:checked").map(function () {
            return $(this).val();
        }).get();

        let values = new Set();
        $("#order_table2 tbody tr").each(function () {
            values.add(orderTable2CellValue(this.children[col]));
        });

        // 選択肢が多いので jQuery で 1 つずつ作らず、まとめて追加する
        let fragment = document.createDocumentFragment();
        Array.from(values).sort().forEach(function (val) {
            let label = document.createElement("label");
            label.className = "me-2 text-nowrap";
            let input = document.createElement("input");
            input.type = "checkbox";
            input.value = val;
            input.checked = checked.includes(val);
            label.append(input, " " + (val === "" ? "(空欄)" : val));
            fragment.append(label);
        });
        container.html('<button type="button" class="btn btn-sm mb-2 clear-col-filter">クリア</button>');
        container[0].append(fragment);
    });
    applyOrderTable2Filter();
}

// index3 の列フィルターを適用する
function applyOrderTable2Filter() {
    let filters = [];
    $("#order_table2 .col-filter").each(function () {
        let checked = $(this).find("input:checked").map(function () {
            return $(this).val();
        }).get();
        $(this).closest(".position-relative").find(".col-filter-btn")
            .toggleClass("btn-success", checked.length > 0)
            .toggleClass("btn-primary", checked.length == 0);
        if (checked.length > 0) {
            filters.push({ col: $(this).data("col"), values: checked });
        }
    });

    // 行数が多いと遅いため、jQuery の toggle() ではなく style を直接切り替える
    $("#order_table2 tbody tr").each(function () {
        let row = this;
        let show = filters.every((f) => f.values.includes(orderTable2CellValue(row.children[f.col])));
        row.style.display = show ? "" : "none";
        // 非表示の行は一括操作のチェックを外す
        if (!show) {
            row.querySelectorAll('input[type="checkbox"]:checked').forEach((cb) => (cb.checked = false));
        }
    });

    displayColmun2();
}

if($('#account_book').length > 0){
    displayColmun3();

    //フラグを付ける／外す（同じ受注の行のフラグもまとめて切り替える）
    $(document).on("click", "#account_book .ab-flag", function () {
        const orderId = $(this).data("order-id");
        $.ajax({
            url: "/ajax/do_action_order_flag",
            type: "POST",
            dataType: "json",
            data: { order_id: orderId },
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
        })
            .done((data) => {
                if (data.status) {
                    $('#account_book .ab-flag[data-order-id="' + orderId + '"]')
                        .toggleClass("on bi-flag-fill", data.flag)
                        .toggleClass("bi-flag", !data.flag);
                } else {
                    showToast("エラーが発生しました", "danger", 3000);
                }
            })
            .fail(() => {
                showToast("エラーが発生しました", "danger", 3000);
            });
    });
}

function displayColmun() {
    $("#order_table tbody td").css("visibility", "visible");

    let prevKey = null;

    $("#order_table tbody tr:visible").each(function () {
        const $cells = $(this).find("td");
        const col1 = $cells.eq(0).text().trim();
        const col2 = $cells.eq(1).text().trim();

        // 1カラム目 + 2カラム目の組み合わせ
        const key = col1 + "||" + col2;

        if (prevKey === key) {
            // 両方同じなら、1・2カラム目を非表示
            $cells.eq(0).css("visibility", "hidden");
            $cells.eq(1).css("visibility", "hidden");
            $cells.eq(2).css("visibility", "hidden");
            $cells.eq(3).css("visibility", "hidden");
            $cells.eq(4).css("visibility", "hidden");
            $cells.eq(5).css("visibility", "hidden");
            $cells.eq(6).css("visibility", "hidden");
        } else {
            prevKey = key;
        }
    });
}

function displayColmun2() {
    // 前の行と受注No.・顧客名が同じ行は 1〜7 列目を隠す（style.css の tr.dup-row）
    // 行数が多いと遅いため、:visible やセルごとの css 変更は使わず行の class だけを切り替える
    let prevKey = null;

    $("#order_table2 tbody tr").each(function () {
        if (this.style.display === "none") return; // フィルターで非表示の行

        const cells = this.children;
        // 1カラム目 + 2カラム目の組み合わせ
        const key = cells[0].textContent.trim() + "||" + cells[1].textContent.trim();
        const dup = prevKey === key;

        this.classList.toggle("dup-row", dup);
        if (!dup) prevKey = key;
    });
}

function displayColmun3() {
    // 前の行と Ord.No が同じ行は 1〜36 列目（納品日・納品の期を除く）を隠す（style.css の #account_book tr.dup-row）
    // 行数が多いと遅いため、:visible やセルごとの css 変更は使わず行の class だけを切り替える
    let prevKey = null;

    $("#account_book tbody tr").each(function () {
        const key = this.children[0].textContent.trim();

        // ディスカウント・手数料行（1カラム目が空）は対象外
        if (key === "") {
            prevKey = null;
            return;
        }

        const dup = prevKey === key;
        this.classList.toggle("dup-row", dup);
        if (!dup) prevKey = key;
    });
}

/**
 * Toastを表示
 * @param {string} message - 表示するメッセージ
 * @param {string} type - 'success' or 'danger'
 * @param {number} duration - 自動消去までの時間（ミリ秒）
 */
// 成功時
//showToast('処理が成功しました！', 'success', 3000);

// エラー時
//setTimeout(() => {
//    showToast('エラーが発生しました！', 'danger', 3000);
//}, 3500);
function showToast(message, type = "success", duration = 3000) {
    // typeを安全に設定
    const validType = ["success", "danger", "warning", "info"].includes(type)
        ? type
        : "success";

    // Toast 要素作成
    const toastEl = document.createElement("div");
    toastEl.className = `toast align-items-center text-bg-${validType} border-0`;
    toastEl.setAttribute("role", "alert");
    toastEl.setAttribute("aria-live", "assertive");
    toastEl.setAttribute("aria-atomic", "true");
    toastEl.innerHTML = `
        <div class="d-flex">
            <div class="toast-body">${message}</div>
            <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
        </div>
    `;

    // コンテナに追加
    const container = document.getElementById("toastContainer");
    container.appendChild(toastEl);

    // Bootstrap Toast インスタンス作成
    const bsToast = new bootstrap.Toast(toastEl, { delay: duration });
    bsToast.show();

    // 自動でDOMから削除
    toastEl.addEventListener("hidden.bs.toast", () => {
        toastEl.remove();
    });
}

function initExTableFilter() {
    // index3 は専用の列フィルター（選択中のチェックを残して作り直す）
    if ($("#order_table2").length > 0) {
        buildOrderTable2Filter();
        return;
    }
    // --- 列ごとのチェックボックスリスト生成 ---
    $("#order_table thead th").each(function (colIndex) {
        let uniqueVals = new Set();

        $("#order_table tbody tr").each(function () {
            let val = $(this).find("td").eq(colIndex).text().trim();
            uniqueVals.add(val);
        });

        // チェックボックスを生成して div.filterX に追加
        let container = $(`.filter${colIndex}`);
        container.html("");

        uniqueVals.forEach(function (val) {
            let cb = $(
                `<label class="me-2"><input type="checkbox" data-col="${colIndex}" value="${val}"> ${val}</label>`
            );
            container.append(cb);
        });
    });
}

$(document).on("click", function (e) {
    // collapse内、もしくはトグルボタンをクリックした時は何もしない
    if ($(e.target).closest('.collapse, [data-bs-toggle="collapse"]').length) {
        return;
    }

    // 全ての collapse を閉じる
    $(".collapse.show").each(function () {
        let collapse = bootstrap.Collapse.getInstance(this);
        if (!collapse) {
            collapse = new bootstrap.Collapse(this, { toggle: false });
        }
        collapse.hide();
    });
});


// 送金の新規登録・編集：REM DAYを選んだらREM No.（REM+yymmdd）を自動入力（手で変えていても上書き）
if ($("#rem_no").length > 0) {
    $("#rem_day").on("change", function () {
        let m = $(this).val().match(/^\d{2}(\d{2})-(\d{2})-(\d{2})$/);
        if (!m) return;
        $("#rem_no").val("REM" + m[1] + m[2] + m[3]);
    });
}

// 送金の編集：ユーロ円を変えたらREM TTL(￥)をREM TTL(€)×ユーロ円で計算し直す
if ($("#remittance_edit").length > 0) {
    $("#euro_to_yen").on("input", function () {
        let euro = parseFloat($("#rem_ttl_yen_edit").data("euro")) || 0;
        let rate = parseFloat($(this).val()) || 0;
        $("#rem_ttl_yen_edit").text(Math.round(euro * rate).toLocaleString());
    });
}

if ($("#remittance_form").length > 0) {
    function calculateTotal() {
        let total = 0;
        let total_yen = 0;

        let euro_to_yen = $('#euro_to_yen').val();

        // 1. すべてのIDをユニークで取得する
        let ids = [];
        $('input[name^="transfer_status"]').each(function() {
            let name = $(this).attr('name');
            let id = name.match(/\[(\d+)\]/)[1];
            if (!ids.includes(id)) {
                ids.push(id);
            }
        });

        // 2. IDごとに計算する
        ids.forEach(function(id) {
            //console.log(id);

            // 選択されているラジオボタンの値を取得
            let statusEl = $('input[name="transfer_status[' + id + ']"]:checked');
            if (statusEl.length === 0) return;

            let status = parseInt(statusEl.val()) || 0;
            let netTtl = parseFloat($('input[name="net_ttl[' + id + ']"]').val()) || 0;
            let depositRate = parseFloat($('input[name="deposit_rate[' + id + ']"]').val()) || 30;

            let rate = depositRate / 100;

            // 残：DEP登録済みなら 100 - DEP%、未登録なら 100%
            let deposited = $('#qp_' + id).data('deposited') == 1;
            let remain_rate = deposited ? 100 - depositRate : 100;

            // DEP未送金のままBALを選んだ場合は100%を一括送金（DEP%は入力不可）
            if (!deposited) {
                let bal_only = status === 2;
                $('input[name="deposit_rate[' + id + ']"]')
                    .prop('readonly', bal_only)
                    .css('background', bal_only ? '#e9ecef' : '');
                if (bal_only) {
                    rate = 0;
                }
            }

            $('#remain_rate_'+id).text(remain_rate+'%');

            if (status === 1) {
                total += netTtl * rate;
            } else if (status === 2) {
                total += (netTtl - (netTtl * rate));
            }
        });

        total=Math.round(total*100)/100;
        total_yen=Math.round(total * euro_to_yen);

        // 3. 表示IDを rem_ttl_euro に変更して反映
        $('#rem_ttl_euro').text('€ '+total.toLocaleString(undefined, {minimumFractionDigits: 2,maximumFractionDigits: 2}));
        $('#rem_ttl_euro_input').val(total);

        $('#rem_ttl_yen').text('￥'+total_yen.toLocaleString(undefined, {minimumFractionDigits: 0}));
        $('#rem_ttl_yen_input').val(total_yen);
    }

    // イベント設定
    $(document).on('change', 'input[name^="transfer_status"]', calculateTotal);
    $(document).on('input', 'input[name^="deposit_rate"]', calculateTotal);
    $(document).on('input', '#euro_to_yen', calculateTotal);

    calculateTotal();
}


if($("#create_order_form").length > 0){
    $("#split_rate").on('input', function() {
        // 入力された値を取得
        var val = Number($(this).val());
        console.log('入力中の値:', val);
        var total=$('#deposit').data('total');

        if(val>0){
            var deposit = Math.floor((total * val /100) / 100) * 100;
            var balance = total-deposit;
            $("#deposit").val(deposit);
            $("#balance").val(balance);
        }else{
            $("#deposit").val(total);
            $("#balance").val(0);
        }
        // 入金額が空欄のときに見せる予定額（受注編集画面）
        $("#payment_price").attr("placeholder", $("#deposit").val());
        $("#payment_price2").attr("placeholder", $("#balance").val());
    });
}

// 受注編集：諸経費（経費・返金・求償）タグ
if ($("#orderEventModal").length > 0) {
    $("#order_event_check_all").on("change", function () {
        $('input[name="order_event_products[]"]').prop("checked", $(this).prop("checked"));
    });

    //イベント登録（選択した明細に紐付け）
    $("#do_action_regist_order_event").on("click", function () {
        let $modal = $("#orderEventModal");
        let $date = $modal.find('input[name="event[event_date]"]');
        let $fee = $modal.find('input[name="event[event_fee]"]');
        let ids = $('input[name="order_event_products[]"]:checked')
            .map(function () {
                return $(this).val();
            })
            .get();

        // 空欄チェック
        let $empty = [$date, $fee].find(($el) => $el.val() == "");
        if ($empty) {
            showToast("未入力の項目があります。すべて入力してください。", "danger");
            $empty.focus();
            return;
        }
        if (ids.length == 0) {
            showToast("紐付ける明細を選択してください。", "danger");
            return;
        }

        $(this).prop("disabled", true);
        $.ajax({
            url: "/ajax/do_action_regist_order_event",
            type: "POST",
            data: {
                order_id: $("#order_event_wrap").data("order-id"),
                ids: ids,
                event: {
                    event_type_id: $modal.find('input[name="event[event_type_id]"]:checked').val(),
                    event_date: $date.val(),
                    event_fee: $fee.val(),
                    event_note: $modal.find('textarea[name="event[event_note]"]').val(),
                },
            },
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
            dataType: "json",
        })
            .done((data) => {
                if (data.status) {
                    $("#order_event_wrap").append(
                        '<span id="order-event-' + data.event_id + '" data-id="' + data.event_id + '">' +
                            data.name +
                            ' <button type="button" class="btn-close"></button></span>'
                    );
                    $modal.modal("hide");
                    $date.val("");
                    $fee.val("");
                    $modal.find('textarea[name="event[event_note]"]').val("");
                    showToast("処理が成功しました", "success", 3000);
                } else {
                    showToast("エラーが発生しました", "danger", 3000);
                }
            })
            .fail((jqXHR) => {
                let message = jqXHR.responseJSON?.message ?? "エラーが発生しました";
                showToast(message, "danger", 3000);
            })
            .always(() => {
                $(this).prop("disabled", false);
            });
    });

    //受注との紐付け解除（イベントは残す）
    $(document).on("click", "#order_event_wrap .btn-close", function () {
        let $tag = $(this).parent("span");
        $.ajax({
            url: "/ajax/do_action_order_event_delete",
            type: "POST",
            dataType: "json",
            data: {
                order_id: $("#order_event_wrap").data("order-id"),
                event_id: $tag.data("id"),
            },
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
        })
            .done((data) => {
                if (data.status) {
                    $tag.remove();
                    showToast("受注との紐付けを解除しました", "success", 3000);
                } else {
                    showToast("エラーが発生しました", "danger", 3000);
                }
            })
            .fail(() => {
                showToast("エラーが発生しました", "danger", 3000);
            });
    });
}
